export default "__VITE_ASSET__c1700bef__"